import React from "react";
import data from "../data/cta.json";
import ReCAPTCHA from "react-google-recaptcha";

const Cta = ({ isBg }) => {
  const { cta } = data;
  const recaptchaRef = React.createRef();

  return (
    <section
      className={`cta section-padding ${isBg === "yes" ? "bg-one" : ""}`}
      id="cta"
      style={{ backgroundImage: `url("${cta.backgroundImage}")` }}
    >
      <div className="container">
        <div className="row justify-content-center cta__inner bg-one">
          <div className="col-lg-8">
            <div className="section-title-center mb-0 text-center">
              <span
              >
                {cta.subtitle}
              </span>
              <h2
                className="display-6"
              >
                {cta.title}
              </h2>
            </div>
            <div className="cta-form-box">
              <form action="https://listmanager.jutefoster.com/subscribe" method="POST" accept-charset="utf-8">
                <input type="email" name="email" id="email" placeholder="Your email" />
                <div className="cta__recaptcha"><ReCAPTCHA ref={recaptchaRef} sitekey={process.env.REACT_APP_SITE_KEY} /></div>
                <div style={{ display: 'none' }}>
                  <label for="hp">HP</label><br />
                  <input type="text" name="hp" id="hp" />
                </div>
                <input type="hidden" name="list" value="dHtjAH0MhKZDyGvdNnjDXQ" />
                <input type="hidden" name="subform" value="yes" />
                <button name="submit" id="submit" class="w-100 button button__primary align-items-center aos-init"><span>Submit</span></button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Cta;
